import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import NonAffiliatedStudentsComponentsStep0Component from "./components/non-affiliated-students-components-step0/non-affiliated-students-components-step0";
import NonAffiliatedStudentsComponentsStep0Part1 from "./components/non-affiliated-students-components-step0/non-affiliated-students-components-step0-parts/non-affiliated-students-components-step0-part1";
import NonAffiliatedStudentsComponentsStep1Component from "./components/non-affiliated-students-components-step1/non-affiliated-students-components-step1";
import NonAffiliatedStudentsComponentsStep1Part1 from "./components/non-affiliated-students-components-step1/non-affiliated-students-components-step1-parts/non-affiliated-students-components-step1-part1";
import NonAffiliatedStudentsComponentsStep2Component from "./components/non-affiliated-students-components-step2/non-affiliated-students-components-step2";
import NonAffiliatedStudentsComponentsStep2Part1 from "./components/non-affiliated-students-components-step2/non-affiliated-students-components-step2-parts/non-affiliated-students-components-step2-part1";

class Scenario2NonAffiliatedStudentsVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 2 Non-Affiliated Students';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 2 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario02/sc02-cinematic/cin-sc-2.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario02/sc02-mentor/mntr-sc-02.mp4', //Need to add the audio files from the 3 employees after the mentor file finishes.
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario02/sc02-mentor/mntr-sc-02.mp4', // change this
				chapterIds: [
					'scenario2-6', //question 1 correct
					'scenario2-4', //question 1 incorrect
					'scenario2-5', //question 1 other option - don't delete comment!
					'scenario2-10',//question 2 correct - don't delete comment!
					'scenario2-8', //question 2 incorrect - don't delete comment!
					'scenario2-9', //question 2 other option - don't delete comment!
					'scenario2-14', //question 3 correct - don't delete comment!
					'scenario2-13', //question 3 incorrect - don't delete comment!
					'scenario2-16', //question 4 correct - don't delete comment!
					'scenario2-17', //question 4 incorrect - don't delete comment!
					'scenario2-18', //question 4 other option - don't delete comment!
					'scenario2-20', //question 5 correct - don't delete comment!
					'scenario2-21', //question 5 incorrect - don't delete comment!
					'scenario2-2', //scenario info // fix for beta, Alan will make into one chapter for scenario 02
					'scenario2-22' //scenario review 
				]
			}
		];
	}
}

export const scenario2NonAffiliatedStudentsVideoSegments = new Scenario2NonAffiliatedStudentsVideoSegments();

class Scenario2NonAffiliatedStudentsAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-02/mentor/jcdst-mentor-vo-scn-02-02.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-02/mentor/jcdst-mentor-vo-scn-02-07.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-02/mentor/jcdst-mentor-vo-scn-02-13.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-02/mentor/jcdst-mentor-vo-scn-02-17.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-02/mentor/jcdst-mentor-vo-scn-02-22.mp3'
			}
		];
	}
}

export const scenario2NonAffiliatedStudentsAudioCaching = new Scenario2NonAffiliatedStudentsAudioCaching();

export default class Scenario2NonAffiliatedStudents extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario2NonAffiliatedStudents,
			title: 'Non-Affiliated Students',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				Chris brought in unauthorized respiratory technician students to the ICU. They were 
				found reviewing medical records and asking for access to VHA electronic patient record system.  
				</p>
			`,
			mentorVideoUrl: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('MixedMedia'),
			scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as NonAffiliatedStudentsComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as NonAffiliatedStudentsComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as NonAffiliatedStudentsComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as NonAffiliatedStudentsComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as NonAffiliatedStudentsComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as NonAffiliatedStudentsComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as NonAffiliatedStudentsComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;

	public scenarioId(): PageType {
		return PageType.Scenario2NonAffiliatedStudents;
    }

	private video: SingleVideoSegmentItem = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Scenario 2 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
		title: 'Non-Affiliated Students',
		subtitle: 'Incident Report',
		name: 'Chris',
		position: 'Respiratory Therapist',
		time: '1:00 pm',
		place: 'Intensive Care Unit',
		desc: `Chris brought unauthorized respiratory technician students to the ICU. 
		 	They were found reviewing medical records and asking for access to 
			VHA electronic patient record system. `,
		repeat: 'Yes',
		okButton: 'Continue'
		}
	}

	private step0Component = new NonAffiliatedStudentsComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new NonAffiliatedStudentsComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new NonAffiliatedStudentsComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}